import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button } from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";

let style = Object.assign({}, global);

const ProposalStatusChangeModal = props => {
  const [isDisable, setIsDisable] = useState();

  const close = () => {
    if (document.querySelector(".publish-modal")) document.querySelector(".publish-modal").style.display = "block";
    props.setShowModal(!props.showModal);
  };

  return (
    <React.Fragment>
      {props.modalData.name === "Declined" && (
        <>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>Change Status to Declined</h4>

          <span aria-label="Close" className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
            <Icon icon="ui-close" />
          </span>

          <div>
            <div className={cx(style["delete-msg"], style["font-base"], style["color-33"], style["mb-4"])}>
              When you change the status to declined, the document will be locked and would not be editable. Viewers
              will not be able to access the content of the published page.
              <div className={cx(style["mt-3"])}>Are you sure to change the status to declined?</div>
            </div>

            <Button
              type="submit"
              color="danger"
              onClick={() => {
                (setIsDisable(true), props.updateProposalStatus(props.modalData));
              }}
              disabled={isDisable}>
              Yes
            </Button>
          </div>
        </>
      )}

      {props.modalData.name === "Live" && (
        <>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>Change Status to Live</h4>

          <span aria-label="Close" className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
            <Icon icon="ui-close" />
          </span>

          <div>
            <div className={cx(style["delete-msg"], style["font-base"], style["color-33"], style["mb-4"])}>
              When you change the status to live, the document will be editable until it is accepted or declined.
              Viewers will be able to access the content of the published page.
              <div className={cx(style["mt-3"])}>Are you sure to change the status to live?</div>
            </div>

            <Button
              type="submit"
              color="danger"
              onClick={() => {
                (setIsDisable(true), props.updateProposalStatus(props.modalData));
              }}
              disabled={isDisable}>
              Yes
            </Button>
          </div>
        </>
      )}

      {props.modalData.name === "Expired" && (
        <>
          <h4 className={cx(style["fw-7"], style["mb-4"])}>Change Status to Expired</h4>

          <span aria-label="Close" className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
            <Icon icon="ui-close" />
          </span>

          <div>
            <div className={cx(style["delete-msg"], style["font-base"], style["color-33"], style["mb-4"])}>
              When you change the status to expired, the document will be locked and would not be editable. Viewers will
              not be able to access the content of the published page.
              <div className={cx(style["mt-3"])}>Are you sure to change the status to expired?</div>
            </div>

            <Button
              type="submit"
              color="danger"
              onClick={() => {
                (setIsDisable(true), props.updateProposalStatus(props.modalData));
              }}
              disabled={isDisable}>
              Yes
            </Button>
          </div>
        </>
      )}
    </React.Fragment>
  );
};
ProposalStatusChangeModal.propTypes = {
  modalData: PropTypes.string.obj,
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  updateProposalStatus: PropTypes.func,
};

export default ProposalStatusChangeModal;
